module.exports = __webpack_public_path__ + "img/1726044324067-screenshot-1726044314799.png.6bd49993.webp";